module.exports = import("https://milo.adobe.com/tools/send-to-caas/send-to-caas.js");;